export const outputError = ({ err, source }) => {
    if (err.response?.data?.message) {
        console.error(`[ERROR:${source}] ${err.response?.data?.message}`);
    } else {
        console.error(`[ERROR:${source}] ${err.message}`);
    }
};
